/**
 * useCustomFieldFilter — filtro por CAMPO PERSONALIZADO, compartilhado pelos 4
 * inboxes.
 *
 * Por que hook e não estado repetido em cada ChatList: os 4 shells já duplicam
 * Inbox/ChatList/ChatWindow; o filtro por campo é CORE (o operador não sabe
 * dizer em qual inbox está olhando quando filtra "MODELO = Civic"), então a
 * lógica mora num arquivo só e cada shell só faz a fiação.
 *
 * O catálogo de campos é do WORKSPACE (o backend resolve o dono), cacheado
 * pelo customFieldsService. Só devolve os tipos FILTRÁVEIS: data e checkbox
 * ficam de fora porque na tela não têm um controle que valha a pena.
 *
 * Formato de saída (`values`): [{ field_id, value }], que os serviços dos 4
 * canais serializam como `?cf=campo:valor` — mesmo formato de fio do motor
 * core do backend (services/custom_field_search.py).
 */
import { useCallback, useEffect, useState } from 'react';
import customFieldsService from '../services/global/customFieldsService';

const TIPOS_FILTRAVEIS = new Set([
  'text', 'textarea', 'number', 'currency', 'select', 'multiselect',
]);

export default function useCustomFieldFilter() {
  const [fields, setFields] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    let vivo = true;
    customFieldsService
      .getSchema()
      .then((schema) => {
        if (!vivo) return;
        const defs = (schema?.definitions || [])
          .filter((d) => d?.id && TIPOS_FILTRAVEIS.has(d.type))
          .map((d) => ({
            id: d.id,
            name: d.name || d.id,
            type: d.type,
            options: d.options || [],
          }));
        setFields(defs);
      })
      // Sem campos o drawer some com a seção inteira — falha aqui degrada para
      // "não tem filtro por campo", nunca para tela quebrada.
      .catch(() => { if (vivo) setFields([]); });
    return () => { vivo = false; };
  }, []);

  const clear = useCallback(() => setValues([]), []);

  return { fields, values, setValues, clear, active: values.length > 0 };
}
